import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import CollectionToolbar from "@/components/collection/CollectionToolbar";
import CollectionGrid from "@/components/collection/CollectionGrid";
import { useCollection } from "@/lib/useCollection";
import { journalEntries } from "@/data/journal";
import { images } from "@/data/images";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export default function Journal() {
  const collection = useCollection(journalEntries, {
    pageSize: 6,
    searchKeys: ["title", "excerpt", "category", "type"],
  });
  const [selected, setSelected] = useState(null);

  return (
    <div data-testid="journal-page">
      <PageHeader
        eyebrow="Coaching Journal"
        title="Ideas from the gym and the film room."
        intro="A living archive of articles, coaching journals, film breakdowns, and leadership lessons — growing with every season."
        image={images.coachSideline}
      />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <CollectionToolbar
            collection={collection}
            searchPlaceholder="Search articles, journals, breakdowns..."
            testidPrefix="journal"
          />
          <div className="mt-4">
            <CollectionGrid
              collection={collection}
              onItemClick={setSelected}
              testidPrefix="journal"
              emptyLabel="No entries match your search yet."
            />
          </div>
        </div>
      </section>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent
          data-testid="journal-detail-dialog"
          className="max-w-2xl bg-ink-surface border-white/10 text-white max-h-[90vh] overflow-y-auto"
        >
          {selected && (
            <>
              <DialogHeader>
                <span className="text-[10px] uppercase tracking-[0.2em] text-gold">
                  {selected.type} · {selected.category}
                </span>
                <DialogTitle className="font-heading text-2xl md:text-3xl font-semibold text-white text-left">
                  {selected.title}
                </DialogTitle>
                <DialogDescription className="text-zinc-500 text-left">
                  {selected.date} · {selected.readTime}
                </DialogDescription>
              </DialogHeader>
              {selected.thumbnail && (
                <img
                  src={selected.thumbnail}
                  alt=""
                  className="w-full h-52 object-cover border border-white/10 opacity-80"
                />
              )}
              <div className="space-y-4">
                {selected.body?.map((p, i) => (
                  <p key={i} className="text-zinc-400 leading-relaxed">
                    {p}
                  </p>
                ))}
                {selected.status === "coming-soon" && (
                  <p className="text-xs text-gold italic border-l-2 border-gold/40 pl-4">
                    Full entry coming soon — this is a preview of upcoming content.
                  </p>
                )}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
